<template>
    <div class="question_field mx-2">
        <slot name="meta" />
        <strong v-if="!config.useQuestionAsLabel">{{question.FormQuestionTitle}}</strong>
        <div v-if="question.FormQuestionContent" v-html="question.FormQuestionContent"></div>
        <v-text-field :disabled="disableField" :label="field_label" :rules="question_rules" :hint="config.hint" :prefix="config.prefix" :prepend-icon="config.prependIcon" :suffix="config.suffix" :append-icon="config.appendIcon" :maxlength="config.characterLimit" v-model="value.AnswerContent"></v-text-field>
        <slot></slot>
    </div>
</template>
<script>
import FmlFieldMixins from './FmlFieldMixins.vue'
export default {
    name: "FmlTextField",
    mixins: [FmlFieldMixins],
    data: function() {
        return {
            AnswerDataType: 'String'
        }
    },
    computed: {
        config() {
            return this.question.FormQuestionConfig
        },
    },
}
</script>
